var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"src":("/zoom.html?meetingConfig=" + (encodeURIComponent(JSON.stringify(_vm.meetingConfig)))),"frameBorder":"0","allow":"camera;microphone","height":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }